const PluginLocations = {
    ResultViewDocument: 'ResultViewDocument',
    ResultViewToolbar: 'ResultViewToolbar'
};
export default PluginLocations;